import { SwiperOptions } from 'swiper/types';

// 마플샵 홈에서 사용하는 auto play 있는 swiper 옵션 생성 함수
export const makeSwiperAutoPlayOption = (options: { is_mobile: boolean }): SwiperOptions => {
  return {
    autoplay: options.is_mobile
      ? false
      : {
          delay: 3000,
        },
    loop: true,
    slidesPerView: options.is_mobile ? 'auto' : 4,
    slidesPerGroup: 1,
    speed: 600,
    spaceBetween: options.is_mobile ? 0 : 24,
    scrollbar: {
      draggable: true,
    },
  };
};
